<template>
  <SDialog title="Table" :persistent="true" :width="450" @close="closeModal">
    <div style="padding: 24px" v-grid="1">
      <SButton title="Add Row" @click="addRow" />
      <div v-if="rows.length > 0">
        <div v-for="(row, index) in rows" :key="index + '_row'">
          <strong> ROW {{ index + 1 }} </strong><br />
          <div>Border</div>
          <!-- <SSwitch v-model="row.border" labels /> -->
          <SButton title="Add Column" @click="addColumn(index)" />
          <div
            v-for="(col, colIndex) in row.columns"
            :key="colIndex + '_col_row_' + index"
            class="columns"
            v-margin-y="16"
          >
            <strong>Column {{ colIndex + 1 }}</strong>
            <br />

            <!-- <SInput label="width (%)" v-model="col.width" type="number" /> -->
            <!-- <div></div> -->
            <div>
              <div>Border</div>
              <!-- <SSwitch v-model="col.border" labels /> -->
            </div>
          </div>
        </div>
      </div>
      <SButton title="Add" @click="addTable" />
    </div>
  </SDialog>
</template>
<script>
import SDialog from "../SDialog";
import SInput from "../SInput.vue";
import SButton from "../SButton.vue";
import SSwitch from "../SSwitch.vue";

export default {
  name: "Table",
  components: { SDialog, SInput, SButton, SSwitch },
  data() {
    return {
      numberOfRows: null,
      rows: [],
    };
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    addRow(val) {
      this.rows.push({
        border: false,
        columns: [],
      });
    },
    addColumn(index) {
      this.rows[index].columns.push({
        a: [],
      });
    },
    addTable() {
      this.$emit("addRows", this.rows);
    },
  },
  created() {},
  validations: function () {
    return {};
  },

  props: {},
};
</script>

<style lang="scss" scoped>
.columns {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 16px;
  row-gap: 16px;
  align-items: center;
}
</style>